import { primaryKey, editableOnNew, headerCode, inputType, required, length, order, pattern, editable, Describer, visible, GceEntity, textAlign } from './gce-management';

/**
 * GceFiscalReg
 */
export class GceFiscalReg extends GceEntity {
    @primaryKey()
    @headerCode('GCE.GCEFISCALREG.TIPO_REGIME')
    @inputType('text')
    @editable(false)
    @editableOnNew(false)
    @order(1)
    tipo_regime: string;

    @headerCode('GCE.GCEFISCALREG.DESCRIZIONE')
    @inputType('text')
    @required()
    @editable(true)
    @length(255)
    @order(2)
    descrizione: string;


    constructor();
    constructor(tipo_regime: string, descrizione: string);
    constructor(tipo_regime?: string, descrizione?: string){
        super();
        this.tipo_regime = tipo_regime || '';
        this.descrizione = descrizione || '';
    }

    static getStructure(): Array<any> {
        let structure: any[] = Describer.getStructure(new GceFiscalReg());
        structure.push(...this.getActions());
        return structure;
    }
    protected static getActions(): any[] {
        let actions: any[] = [];
        return actions;
    }
}